import React from 'react';
import styles from './SocialMedia.module.css';

const SocialMediaContent = () => {
  const googleFormUrl = 'https://forms.gle/ce1boZcVYeNhJXPC8';

  return (
    <div className={styles.container}>
      {/* Header Box */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            <h1 className={styles.headerTitle}>Submit Content</h1>
            <p className={styles.headerSubtitle}>
              Get your jewellery featured on our Instagram and reach thousands of potential customers
            </p>
          </div>
          <div className={styles.headerActions}>
            <a
              href={googleFormUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.submitButton}
            >
              Submit Your Content
            </a>
          </div>
        </div>
      </div>

      {/* Status Badge Box */}
      <div className={styles.statusCard}>
        <div className={styles.statusBadge}>
          <span className={styles.statusDot}></span>
          <span>In Development: On-Page Form Coming Soon</span>
        </div>
        <p className={styles.statusDescription}>
          We're building an integrated form right here in the portal. In the meantime,
          you can submit your content using our Google Form by clicking the button above.
        </p>
      </div>

      {/* Benefits Section */}
      <div className={styles.contentCard}>
        <h2 className={styles.sectionTitle}>Why Submit Your Content?</h2>
        <div className={styles.benefitsGrid}>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>1</div>
            <h3 className={styles.benefitTitle}>Free Exposure</h3>
            <p className={styles.benefitText}>
              Get your work showcased to our growing Instagram audience at no cost
            </p>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>2</div>
            <h3 className={styles.benefitTitle}>Reach New Customers</h3>
            <p className={styles.benefitText}>
              Connect with thousands of people actively looking for unique jewellery
            </p>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>3</div>
            <h3 className={styles.benefitTitle}>Build Your Brand</h3>
            <p className={styles.benefitText}>
              Increase brand awareness and establish yourself in the marketplace
            </p>
          </div>
        </div>
      </div>

      {/* Instagram Examples Box */}
      <div className={styles.contentCard}>
        <h2 className={styles.sectionTitle}>See Your Work Featured</h2>
        <p className={styles.sectionSubtitle}>
          Here's some content that was shared with us recently
        </p>
        
        <div className={styles.imageGrid}>
          <div className={styles.imageBox}>
            <img 
              src="/instagram-example-1.jpg" 
              alt="Instagram post example 1"
              className={styles.exampleImage}
            />
          </div>
        
          <div className={styles.imageBox}>
            <img 
              src="/instagram-example-2.jpg" 
              alt="Instagram post example 2"
              className={styles.exampleImage}
            />
          </div>
          
          <div className={styles.imageBox}>
            <img 
              src="/instagram-example-3.jpeg" 
              alt="Instagram post example 3"
              className={styles.exampleImage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaContent;
